<h2 mat-dialog-title>
  @if (loadSearch?.id) {
    Update Load Search
  } @else {
    New Load Search
  }
</h2>

<form [formGroup]="form" (ngSubmit)="saveSearch()">
  <mat-dialog-content class="load-search-dialog-content">
    <div class="template-row">
      <mat-form-field appearance="outline" [formGroup]="templateForm" class="template-field">
        <mat-label>Template</mat-label>

        <mat-select formControlName="id" (selectionChange)="onTemplateChange()">
          <mat-option [value]="null">None</mat-option>

          @for (template of templates; track template.id) {
            <mat-option [value]="template.id">
              {{ template.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="template-actions">
        <button mat-icon-button matTooltip="Add" type="button" (click)="addTemplate()">
          <mat-icon>add_circle_outline</mat-icon>
        </button>

        @if (templateForm.get('id')?.value) {
          <button mat-icon-button matTooltip="Copy" type="button" (click)="addTemplate('copy')">
            <mat-icon>content_copy</mat-icon>
          </button>

          <button mat-icon-button matTooltip="Update" type="button" (click)="updateTemplate()">
            <mat-icon>update</mat-icon>
          </button>

          <button mat-icon-button matTooltip="Delete" type="button" (click)="deleteTemplate()">
            <mat-icon>highlight_remove</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="filters-form">
      <div class="inline-row origin-row">
        <mat-form-field appearance="outline" class="location-field">
          <mat-label>Origin</mat-label>

          <input
            #originInput
            type="text"
            matInput
            placeholder="Choose origin"
            formControlName="origin"
            [matAutocomplete]="pickAuto"
            (input)="filter('origin')"
          />

          <span matSuffix class="autocomplete-spinner">
            @if (loadingOrigin()) {
              <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
            }
          </span>

          <mat-autocomplete requireSelection #pickAuto="matAutocomplete">
            @for (option of filteredOriginOptions; track option.id) {
              <mat-option [value]="formatLocation(option)" (onSelectionChange)="onLocationSelected(option, 'origin')">
                {{ formatLocation(option) }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        @if(!isMobile) {
          <mat-form-field appearance="outline" class="radius-field">
            <mat-label>Radius</mat-label>
            <input matInput type="number" formControlName="origin_radius" step="25" />
            <span matTextSuffix>mi</span>

            @if (form.get('origin_radius')?.hasError('max')) {
              <mat-error>
                Maximum radius is {{ maxSearchRadius }} miles
              </mat-error>
            }

            @if (form.get('origin_radius')?.hasError('min')) {
              <mat-error>
                Minimum radius is {{ minSearchRadius }} miles
              </mat-error>
            }
          </mat-form-field>
        }
        
      </div>

      @if(isMobile) {
        <mat-form-field appearance="outline" class="radius-field">
          <mat-label>Radius</mat-label>
          <input matInput type="number" formControlName="origin_radius" step="25" />
          <span matTextSuffix>mi</span>

          @if (form.get('origin_radius')?.hasError('max')) {
            <mat-error>
              Maximum radius is {{ maxSearchRadius }} miles
            </mat-error>
          }

          @if (form.get('origin_radius')?.hasError('min')) {
            <mat-error>
              Minimum radius is {{ minSearchRadius }} miles
            </mat-error>
          }
        </mat-form-field>
      }

      <!-- Destination Tabs -->
      <mat-tab-group
        class="mini-tab-group"
        [(selectedIndex)]="selectedDestinationTab"
        (selectedTabChange)="onTabChange()"
      >

        <mat-tab label="City">
          <div class="tab-content destination-row mt-10">
            <mat-form-field appearance="outline" class="location-field">
              <mat-label>Destination</mat-label>

              <input
                #destinationInput
                type="text"
                matInput
                placeholder="Choose destination"
                formControlName="destination"
                [matAutocomplete]="deliveryAuto"
                (input)="filter('destination')"
              />

              <span matSuffix class="autocomplete-spinner">
                @if (loadingDestination()) {
                  <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                }
              </span>

              <mat-autocomplete requireSelection #deliveryAuto="matAutocomplete">
                @for (option of filteredDestinationOptions; track option.id) {
                  <mat-option
                    [value]="formatLocation(option)"
                    (onSelectionChange)="onLocationSelected(option, 'destination')"
                  >
                    {{ formatLocation(option) }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            @if(!isMobile){
              <mat-form-field appearance="outline" class="radius-field">
                <mat-label>Radius</mat-label>
                <input matInput type="number" formControlName="destination_radius" step="25" />
                <span matTextSuffix>mi</span>

                @if (form.get('destination_radius')?.hasError('max')) {
                  <mat-error>
                    Max is {{ maxSearchRadius }} mi.
                  </mat-error>
                }

                @if (form.get('destination_radius')?.hasError('min')) {
                  <mat-error>
                    Min is {{ minSearchRadius }} mi.
                  </mat-error>
                }
              </mat-form-field>
            }

            <button mat-icon-button class="clear-button" type="button" matTooltip="Clear destination" (click)="clearDestination()">
              <mat-icon>clear</mat-icon>
            </button>
            
          </div>

          @if(isMobile){
            <mat-form-field appearance="outline" class="radius-field">
              <mat-label>Radius</mat-label>
              <input matInput type="number" formControlName="destination_radius" step="25" />
              <span matTextSuffix>mi</span>

              @if (form.get('destination_radius')?.hasError('max')) {
                <mat-error>
                  Maximum radius is {{ maxSearchRadius }} miles
                </mat-error>
              }

              @if (form.get('destination_radius')?.hasError('min')) {
                <mat-error>
                  Minimum radius is {{ minSearchRadius }} miles
                </mat-error>
              }
            </mat-form-field>

          }
        </mat-tab>

        <mat-tab label="States">
          <div class="tab-content states-row mt-10">
            <mat-form-field appearance="outline" class="states-field">
              <mat-label>Destination States</mat-label>

              <mat-select formControlName="destination_states" multiple>
                <mat-select-trigger>
                  <mat-chip-set>
                    @for (stateCode of form.get('destination_states')?.value ?? []; track stateCode) {
                      <mat-chip-row
                        (removed)="removeDestinationState(stateCode)"
                        (click)="$event.stopPropagation()"
                      >
                        {{ stateCode }}

                        <button matChipRemove type="button">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-set>
                </mat-select-trigger>

                @for (state of states; track state.code) {
                  <mat-option [value]="state.code">
                    {{ state.code }} - {{ state.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <button mat-icon-button class="clear-button" type="button" matTooltip="Clear states" (click)="clearDestinationStates()">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </mat-tab>

        <mat-tab label="Exclude">
          <div class="tab-content states-row mt-10">
            <mat-form-field appearance="outline" class="states-field">
              <mat-label>Destination States (Exclude)</mat-label>

              <mat-select formControlName="destination_states_exclude" multiple>
                <mat-select-trigger>
                  <mat-chip-set>
                    @for (stateCode of form.get('destination_states_exclude')?.value ?? []; track stateCode) {
                      <mat-chip-row
                        (removed)="removeDestinationExcludedState(stateCode)"
                        (click)="$event.stopPropagation()"
                      >
                        {{ stateCode }}

                        <button matChipRemove type="button">
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                  </mat-chip-set>
                </mat-select-trigger>

                @for (state of states; track state.code) {
                  <mat-option [value]="state.code">
                    {{ state.code }} - {{ state.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <button
              mat-icon-button
              class="clear-button"
              type="button"
              matTooltip="Clear excluded states"
              (click)="clearDestinationStatesExclude()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>

      <mat-divider class="form-divider"></mat-divider>

      <mat-form-field appearance="outline" class="date-range-field">
        <mat-label>Pickup Date Range</mat-label>

        <mat-date-range-input [rangePicker]="picker">
          <input
            matStartDate
            placeholder="Start date"
            formControlName="origin_start_date"
            [min]="today"
          />

          <input
            matEndDate
            placeholder="End date"
            formControlName="origin_end_date"
            [min]="today"
          />
        </mat-date-range-input>

        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

        <mat-date-range-picker #picker></mat-date-range-picker>

        @if (form.get('origin_start_date')?.hasError('pastDate')) {
          <mat-error>Start date cannot be in the past</mat-error>
        } @else if (form.get('origin_start_date')?.invalid) {
          <mat-error>Invalid start date</mat-error>
        }

        @if (form.get('origin_end_date')?.hasError('pastDate')) {
          <mat-error>End date cannot be in the past</mat-error>
        } @else if (form.get('origin_end_date')?.invalid) {
          <mat-error>Invalid end date</mat-error>
        }
      </mat-form-field>

      <button
        mat-icon-button
        class="clear-button"
        type="button"
        matTooltip="Clear Date Range"
        (click)="clearDateRange()"
      >
        <mat-icon>clear</mat-icon>
      </button>

      <!-- <mat-expansion-panel class="full-width-panel">
        <mat-expansion-panel-header>Additional Options</mat-expansion-panel-header>
      </mat-expansion-panel> -->
      
      <mat-divider class="form-divider"></mat-divider>
      
      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Rate</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input matInput type="number" formControlName="min_rate" step="500" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Rpm</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input matInput type="number" formControlName="min_rpm" step="0.5" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Distance</mat-label>
        <input matInput type="number" formControlName="min_distance" step="250" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Distance</mat-label>
        <input matInput type="number" formControlName="max_distance" step="250" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Weight</mat-label>
        <input matInput type="number" formControlName="max_weight" step="1000" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Len.</mat-label>
        <input matInput type="number" formControlName="max_length" step="12" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Width</mat-label>
        <input matInput type="number" formControlName="max_width" step="12" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Height</mat-label>
        <input matInput type="number" formControlName="max_height" step="12" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Max Well Len.</mat-label>
        <input matInput type="number" formControlName="max_well_length" step="12" />
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clearFilters()">Clear</button>

    <button mat-button type="button" (click)="close()">Close</button>

    <button 
      mat-button 
      class="lightgreen-button" 
      type="submit"
      [disabled]="form.invalid"
    >
      {{ loadSearch?.id ? 'Update' : 'Search' }}
    </button>
  </mat-dialog-actions>
</form>